import { useEffect, useState } from 'react';

type Skull = { left: string; top: string; delay: number };

const generateSkulls = (width: number, height: number): Skull[] => {
  if (!width) return [];

  const isMobile = width < 768;
  const horizontalGap = isMobile ? 80 : 120;
  const verticalGap = isMobile ? 100 : 140;

  const cols = Math.ceil(width / horizontalGap) + 2;
  const rows = Math.ceil((height * 2) / verticalGap) + 2;

  const skulls: Skull[] = [];

  for (let row = 0; row < rows; row++) {
    const isEvenRow = row % 2 === 0;
    const offsetX = isEvenRow ? 0 : horizontalGap / 2;

    for (let col = 0; col < cols; col++) {
      const left = offsetX + col * horizontalGap;
      const top = row * verticalGap;
      const delay = ((row + col) * 0.5) % 30;

      skulls.push({ left: `${left}px`, top: `${top}px`, delay });
    }
  }

  return skulls;
};

export const SkullBackground = () => {
  const [skulls, setSkulls] = useState<Skull[]>([]);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const update = () => {
      setSkulls(generateSkulls(window.innerWidth, window.innerHeight));
    };

    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return (
    <div className="skull-background" aria-hidden="true">
      <div className="skull-container">
        {skulls.map((skull, index) => (
          <div
            key={`skull-${index}`}
            className="skull"
            style={{ left: skull.left, top: skull.top, animationDelay: `-${skull.delay}s` }}
          >
            <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M41.9119 53.0334C51.6845 50.4838 58.2655 43.6856 60.0823 33.5563C62.4566 20.3187 51.6351 4.00449 35.2049 1.05752C18.7748 -1.88945 2.95788 9.6468 0.583537 22.8844C-1.23328 33.0136 2.46012 42.3142 10.7404 48.0849L9.97965 52.3263C9.72885 53.7246 10.6591 55.0614 12.0574 55.3123L38.0535 59.975C39.4518 60.2258 40.7887 59.2956 41.0395 57.8973L41.9119 53.0334ZM22.4971 20.5996C23.401 20.0355 24.591 20.311 25.1551 21.2149L28.5647 26.6785C29.1288 27.5824 28.8533 28.7725 27.9494 29.3365C27.0455 29.9006 25.8554 29.6251 25.2914 28.7212L21.8818 23.2576C21.3177 22.3537 21.5932 21.1636 22.4971 20.5996ZM37.6137 23.7787C38.4567 23.1272 39.6683 23.2825 40.3198 24.1255C40.9713 24.9686 40.8161 26.1802 39.973 26.8317L34.8771 30.7698C34.034 31.4213 32.8225 31.266 32.1709 30.423C31.5194 29.5799 31.6747 28.3683 32.5178 27.7168L37.6137 23.7787ZM24.6378 34.9051C23.76 39.7992 19.0809 43.055 14.1869 42.1772C9.29277 41.2994 6.03695 36.6203 6.91477 31.7262C7.79259 26.8322 12.4716 23.5763 17.3657 24.4542C22.2598 25.332 25.5156 30.011 24.6378 34.9051ZM41.3296 47.0456C46.2236 47.9234 50.9027 44.6676 51.7805 39.7735C52.6583 34.8795 49.4025 30.2004 44.5084 29.3226C39.6144 28.4448 34.9353 31.7006 34.0575 36.5947C33.1797 41.4887 36.4355 46.1678 41.3296 47.0456ZM28.3931 39.0354L31.416 47.4176L22.6454 45.8445L28.3931 39.0354Z"
                fill="white"
              />
            </svg>
          </div>
        ))}
      </div>
    </div>
  );
};
